import React, { memo } from 'react';
import { useWeb5Context } from 'lib/Web5Context';
import { formatDate } from 'lib/dates';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from './styles';

const useStyles = createUseStyles(styles, 'SectionList');

const DateTimeFormatter = ({ date }) => {
    const { locale } = useWeb5Context();
    const classes = useStyles();
    return <span className={classes.dateTimeFormatter}>{formatDate(date, locale)}</span>;
};

export default memo(DateTimeFormatter);
